import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const EditCustomer = lazy(() => import('../../container/pages/CustomersEdit'));
const CustomersList = lazy(() => import('../../container/pages/CustomersList'));

const CustomersRoute = () => {
  return (
    <Routes>
      <Route path="add" component={<EditCustomer />} />
      <Route path="edit/:customerId" component={<EditCustomer />} />
      <Route path="*" element={<CustomersList />} />
    </Routes>
  );
};

export default CustomersRoute;
